import ClassNames from "classnames";
import { FunctionComponent, useState } from "react";
import { useHistory } from "react-router";
import styles from "../stylesheets/components/language-menu-select.module.css";
import { Language, LanguageMenuItem } from "../types/index.js";
import { useDidMountEffect } from "../utils/hooks.js";
import { getTranslations } from "../utils/utils.js";
import Icon from "./Icon.js";

interface Props {
  isPreview: boolean;
  items: LanguageMenuItem[];
  languageId: Language;
  className: string;
}

const translations = {
  de: { selectLanguage: "Sprache wählen" },
  it: { selectLanguage: "selezionare lingua" },
  en: { selectLanguage: "select language" },
  fr: { selectLanguage: "sélectionner la langue" },
};

const LanguageMenuSelect: FunctionComponent<Props> = ({
  isPreview,
  items,
  languageId,
  className,
}) => {
  const languageIds = items.map(({ hrefLang }) => hrefLang);
  const index = languageIds.indexOf(languageId);
  const [selectedIndex, setSelectedIndex] = useState(index);
  const history = isPreview && useHistory();
  const i18n = getTranslations(languageId, translations);

  useDidMountEffect(() => {
    // non existent menu item should not be possible
    const menuItem = items[selectedIndex];
    if (!menuItem) return;

    const { href } = menuItem;
    history ? history.push(href) : (location.href = href);
  }, [selectedIndex]);

  return (
    <div className={ClassNames(styles.LanguageMenu__Inner, className)}>
      <Icon
        className={ClassNames(
          styles.LanguageMenu__Icon,
          styles["LanguageMenu__Icon--front"],
        )}
        glyph="language"
      />
      <span className={styles.LanguageMenu__SelectedItem}>
        {items[selectedIndex]?.children}
        <Icon
          className={ClassNames(
            styles.LanguageMenu__Icon,
            styles["LanguageMenu__Icon--dropdown"],
          )}
          glyph="arrow-down"
        />
      </span>
      <select
        value={selectedIndex}
        className={styles.LanguageMenu__Select}
        aria-label={i18n.selectLanguage}
        onChange={(e) => {
          const value = +e.target.value;
          value !== selectedIndex && setSelectedIndex(value);
        }}
      >
        {items.map(({ href, children }, index) => {
          return (
            <option
              className={styles.LanguageMenu__SelectOption}
              key={href}
              value={index}
            >
              {children}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default LanguageMenuSelect;
